import { __decorate, __metadata } from "tslib";
import { SerializableObject, SerializableMember, NumberType } from '../decorators';
import { Accuracy } from './Accuracy';
let Accuracy1D = class Accuracy1D extends Accuracy {
  constructor(value, unit) {
    super(value, unit);
  }
  valueOf() {
    return this.value.valueOf();
  }
  toString() {
    return this.valueOf().toString();
  }
};
__decorate([SerializableMember({
  numberType: NumberType.DECIMAL
}), __metadata("design:type", Number)], Accuracy1D.prototype, "value", void 0);
Accuracy1D = __decorate([SerializableObject(), __metadata("design:paramtypes", [Number, Object])], Accuracy1D);
export { Accuracy1D };